import { BscConnector } from '@binance-chain/bsc-connector'
import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { WalletLinkConnector } from '@web3-react/walletlink-connector'
import { chainConfigs, ChainId, supportedChains } from '../config/appConfig'

const POLLING_INTERVAL = 3600000

export const injected = new InjectedConnector({ supportedChainIds: supportedChains })

declare global {
  interface Window {
    ethereum: any
  }
}

export function useWalletConnect(chainId: ChainId) {
  const rpcUrl = chainConfigs[chainId].rpcUrlDefault
  return new WalletConnectConnector({
    rpc: { [chainId]: rpcUrl },
    bridge: 'https://bridge.walletconnect.org',
    qrcode: true,
    pollingInterval: POLLING_INTERVAL,
  })
}

// supported networks: https://help.coinbase.com/en/more/coinbase-wallet/getting-started/what-types-of-crypto-does-wallet-support
export function useWalletLink(chainId: ChainId) {
  const rpcUrl = chainConfigs[chainId].rpcUrlDefault
  return new WalletLinkConnector({
    url: rpcUrl,
    appName: 'bZx',
  })
}

export const binance = new BscConnector({ supportedChainIds: [56] })

/**
 * Prompt the user to add network on Metamask, or switch if the wallet is on a different network
 * @returns true if the setup succeeded, false otherwise
 */
export const switchNetwork = async (chainId: ChainId): Promise<boolean> => {
  const provider = window.ethereum
  if (provider) {
    const network = chainConfigs[chainId].chainDetails
    try {
      await provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: `0x${network.chainId.toString(16)}` }],
      })
      return true
    } catch (switchError) {
      console.error(switchError)
      // This error code indicates that the chain has not been added to MetaMask.
      const _switchError = switchError as { code: number }
      if (_switchError.code === 4902) {
        try {
          await provider.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: `0x${network.chainId.toString(16)}`,
                chainName: network.chainName,
                nativeCurrency: network.nativeCurrency,
                rpcUrls: network.rpcUrls,
                blockExplorerUrls: [network.blockExplorer],
              },
            ],
          })
          return true
        } catch (error) {
          console.error(error)
          return false
        }
      } else {
        return false
      }
    }
  } else {
    console.error("Can't setup the BSC network on metamask because window.ethereum is undefined")
    return false
  }
}
